export default __webpack_public_path__ + "static/media/85.8dd62b59.png";